<template>
  <el-container class="OptionForm">
    <el-main class="p-0">
      <el-form :model="data" :rules="rules" ref="form" label-width="70px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="이름" prop="name">
              <el-input v-model="data.name" maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="구분" prop="class_flag">
              <el-radio v-model="data.class_flag" label="1">사양</el-radio>
              <el-radio v-model="data.class_flag" label="2">비고</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="단가" prop="price">
              <ANumberInput
                v-model="data.price"
                :disabled="data.class_flag !== '1'"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="비고" prop="desc">
              <el-input v-model="data.desc" maxlength="100" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-form-item label="사용여부" prop="use_flag">
              <ACheckboxYN v-model="data.use_flag" class="ml-default" />
            </el-form-item>
          </el-col>
          <el-col :span="20" v-if="is_goods">
            <el-form-item label="참조수량" prop="reference_product">
              <div class="inline">
                <ACheckboxYN
                  v-model="data.reference_product_flag"
                  class="ml-default"
                />
              </div>
              <div class="ml-default inline" style="width: 300px;">
                <AProductSelector
                  size="tiny"
                  :disabled="data.reference_product_flag !== 'Y'"
                  :value="resolveProductName(this.data.reference_product_id)"
                  @select="handleSelectRefernceProduct($event)"
                />
              </div>
              <div class="ml-default inline">
                <AHelper>
                  선택시 생산 지시에 추가될 수량은 참조제품의 수량 x 입력한
                  수량이 됩니다.
                </AHelper>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-divider />
      <div class="w-full flex mb-default">
        <div :class="is_goods ? 'w-half' : 'w-full'">
          <div class="w-full page-subtitle">추가 품목</div>
          <div class="w-full">
            <ATable
              ref="table"
              hide-top-panel
              hide-button-insert
              hide-pagination
              :data="data.addition"
              @cell-click="handleCellClickAddition"
            >
              <el-table-column
                type="index"
                label="No"
                prop="index"
                :width="$width.index"
                :index="handleIndex"
              />
              <el-table-column
                label="품목명"
                prop="product_id"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.id === addition_editing_id">
                    <AProductSelector
                      size="tiny"
                      :value="resolveProductName(scope.row.product_id)"
                      @select="handleSelectProduct($event, scope.row)"
                    />
                  </div>
                  <div v-else>
                    {{ resolveProductName(scope.row.product_id) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="소요량" prop="amount" :width="60">
                <template slot-scope="scope">
                  <div v-if="scope.row.id === addition_editing_id">
                    <ANumberInput v-model="scope.row.amount" allowDecimal />
                  </div>
                  <div v-else>
                    {{ scope.row.amount }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="개별수량"
                prop="individual_amount_flag"
                :width="70"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.id === addition_editing_id">
                    <ACheckboxYN v-model="scope.row.individual_amount_flag" />
                  </div>
                  <div v-else>
                    <i
                      class="el-icon-check"
                      v-show="scope.row.individual_amount_flag === 'Y'"
                    />
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="is_use_assembled"
                align="center"
                :width="110"
              >
                <template slot="header">
                  조립품 사용<AHelper
                    >BOM이 있는 품목만 표시되며, 옵션에 [{{ data.name }}]을
                    추가했을 때 체크된 제품은 하위 품목의 재고가 소모되지
                    않습니다.</AHelper
                  >
                </template>
                <template slot-scope="scope">
                  <ACheckboxYN
                    v-if="resolveUseBom(scope.row.product_id)"
                    v-model="scope.row.is_use_assembled_option"
                  ></ACheckboxYN>
                </template>
              </el-table-column> -->
              <el-table-column label="명령" width="120">
                <template slot-scope="scope">
                  <div v-if="scope.row.id !== addition_editing_id">
                    <el-button
                      type="danger"
                      size="mini"
                      :disabled="!has_grant_write"
                      @click="handleClickRemoveAddition(scope.row)"
                      >삭제</el-button
                    >
                  </div>
                  <div v-else>
                    <el-button
                      type="primary"
                      size="mini"
                      :disabled="!has_grant_write"
                      @click="handleClickUpdateAddition(scope.row)"
                      >저장</el-button
                    >
                    <el-button
                      size="mini"
                      @click="handleClickCancelAddition(scope.row)"
                      >취소</el-button
                    >
                  </div>
                </template>
              </el-table-column>
              <div slot="buttons">
                <el-button
                  type="primary"
                  :disabled="!has_grant_write"
                  @click="handleClickCreateAddition"
                  >추가</el-button
                >
              </div>
            </ATable>
          </div>
        </div>
        <div class="w-half" v-if="is_goods">
          <div class="w-full page-subtitle">제외 품목</div>
          <div class="w-full">
            <ATable
              ref="table2"
              class="ml-default"
              hide-top-panel
              hide-button-insert
              hide-pagination
              :data="data.subtraction"
              @cell-click="handleCellClickSubtraction"
            >
              <el-table-column
                type="index"
                label="No"
                prop="index"
                :width="$width.index"
                :index="handleIndex2"
              />
              <el-table-column
                label="품목명"
                prop="product_id"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.id === subtraction_editing_id">
                    <AProductSelector
                      size="tiny"
                      :value="resolveProductName(scope.row.product_id)"
                      @select="handleSelectProduct($event, scope.row)"
                    />
                  </div>
                  <div v-else>
                    {{ resolveProductName(scope.row.product_id) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="명령" width="120">
                <template slot-scope="scope">
                  <div v-if="scope.row.id !== subtraction_editing_id">
                    <el-button
                      type="danger"
                      size="mini"
                      :disabled="!has_grant_write"
                      :loading="load_button"
                      @click="handleClickRemoveSubtraction(scope.row)"
                      >삭제</el-button
                    >
                  </div>
                  <div v-else>
                    <el-button
                      type="primary"
                      size="mini"
                      :disabled="!has_grant_write"
                      :loading="load_button"
                      @click="handleClickUpdateSubtraction(scope.row)"
                      >저장</el-button
                    >
                    <el-button
                      size="mini"
                      @click="handleClickCancelSubtraction(scope.row)"
                      >취소</el-button
                    >
                  </div>
                </template>
              </el-table-column>
              <div slot="buttons">
                <el-button
                  type="primary"
                  :disabled="!has_grant_write"
                  @click="handleClickCreateSubtraction"
                  >추가</el-button
                >
              </div>
            </ATable>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer height="40px">
      <el-button
        type="primary"
        v-shortkey="['f4']"
        :disabled="!is_registerable || !has_grant_write"
        :loading="load_button"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{ $t("button.save") }} (F4)</el-button
      >
      <el-button
        type="danger"
        v-if="!is_new"
        :disabled="!has_grant_write"
        :loading="load_button"
        @click="handleClickDelete"
        >삭 제</el-button
      >
      <el-button class="close-button" @click="closeDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import { form } from "@/common/mixins/form";

export default {
  name: "OptionForm",
  mixins: [form],
  data() {
    var validateReferenceProduct = (rule, value, callback) => {
      if (this.data.reference_product_flag !== "Y") {
        callback();
      } else {
        if (this.data.reference_product_id) {
          callback();
        } else {
          callback(new Error("참조제품을 선택해 주세요."));
        }
      }
    };
    return {
      title: this.$t("title.option"),
      rules: {
        name: [{ required: true, message: "이름을 입력하세요." }],
        reference_product: [{ validator: validateReferenceProduct }],
      },
      addition_new_index: 0,
      subtraction_new_index: 0,
      addition_editing_id: 0,
      subtraction_editing_id: 0,
      addition_old_item: null,
      subtraction_old_item: null,
      load_button: false,
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          id: 0,
          product_kind: this.kind,
          name: "",
          class_flag: "1",
          price: 0,
          use_flag: "Y",
          reference_product_flag: "N",
          reference_product_id: null,
          addition: [],
          subtraction: [],
        };
      },
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
    kind: {
      type: String,
      default: "GOODS",
    },
  },
  computed: {
    ...mapGetters(["table_product"]),
    is_new() {
      return this.data.id < 1;
    },
    is_registerable() {
      return (
        this.addition_editing_id === 0 && this.subtraction_editing_id === 0
      );
    },
    is_goods() {
      return this.kind === "GOODS";
    },
  },
  methods: {
    validReferenceProduct(product_id) {
      if (this.data.reference_product_flag !== "Y") {
        return true;
      }
      if (!this.data.reference_product_id) {
        return true;
      }
      if (this.data.reference_product_id !== product_id) {
        return true;
      }
      this.util.notify_warning(
        this,
        this.title,
        "참조 품목과 동일한 품목입니다."
      );
      return false;
    },
    validAdditionProduct(product_id, id) {
      let item = this.data.addition.filter(
        (d) => d.product_id === product_id && d.id !== id
      );
      if (item.length > 0) {
        this.util.notify_warning(
          this,
          this.title,
          "추가 품목에 동일한 품목이 존재합니다."
        );
        return false;
      }
      return true;
    },
    validSubtractionProduct(product_id, id) {
      let item = this.data.subtraction.filter(
        (d) => d.product_id === product_id && d.id !== id
      );
      if (item.length > 0) {
        this.util.notify_warning(
          this,
          this.title,
          "제외 품목에 동일한 품목이 존재합니다."
        );
        return false;
      }
      return true;
    },
    doRegister() {
      if (this.is_new) {
        this.data.product_kind = this.kind;
      }
      let api = this.is_new ? this.api.createOption : this.api.updateOption;
      let message = this.is_new
        ? this.$t("message.success_create")
        : this.$t("message.success_update");
      this.load_button = true;
      api(this.data).then((res) => {
        this.load_button = false;
        this.handleResult(res, message);
      });
    },
    doDelete() {
      this.load_button = true;
      this.api.deleteOption(this.data).then((res) => {
        this.load_button = false;
        this.handleResult(res, this.$t("message.success_delete"));
      });
    },
    resolveProductName(id) {
      if (!id) {
        return "";
      }
      let product = this.table_product.find((p) => p.id === id);
      return product ? product.name : "";
    },
    resolveUseBom(id) {
      if (!id) {
        return "";
      }
      let product = this.table_product.find((p) => p.id === id);
      return product ? product.bom_flag === "Y" : false;
    },
    handleSelectRefernceProduct(product) {
      if (typeof product === "string") {
        this.data.reference_product_id = null;
      } else {
        this.data.reference_product_id = product.id;
      }
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleIndex2(index) {
      return this.$refs.table2.indexResolver(index);
    },
    handleSelectProduct(product, item) {
      if (typeof product === "string") {
        item.product_id = null;
      } else {
        item.product_id = product.id;
      }
    },
    handleClickCreateAddition() {
      this.addition_new_index--;
      this.addition_old_item = {
        id: this.addition_new_index,
        type_flag: "1",
        product_id: null,
        amount: 1,
        individual_amount_flag: "N",
      };
      this.data.addition.push(this.addition_old_item);
      this.addition_editing_id = this.addition_new_index;
    },
    handleClickCreateSubtraction() {
      this.subtraction_new_index--;
      this.subtraction_old_item = {
        id: this.subtraction_new_index,
        type_flag: "2",
        product_id: null,
      };
      this.data.subtraction.push(this.subtraction_old_item);
      this.subtraction_editing_id = this.subtraction_new_index;
    },
    handleCellClickAddition(item, column) {
      if (!column.property) {
        return;
      }
      if (this.addition_editing_id === item.id) {
        return;
      }
      if (this.addition_editing_id !== 0) {
        this.handleClickCancelAddition(item);
      }
      this.addition_editing_id = item.id;
      this.addition_old_item = this.util.clone(item);
    },
    handleCellClickSubtraction(item, column) {
      if (!column.property) {
        return;
      }
      if (this.subtraction_editing_id === item.id) {
        return;
      }
      if (this.subtraction_editing_id !== 0) {
        this.handleClickCancelSubtraction(item);
      }
      this.subtraction_editing_id = item.id;
      this.subtraction_old_item = this.util.clone(item);
    },
    handleClickCancelAddition() {
      let index = this.data.addition.findIndex(
        (i) => i.id === this.addition_editing_id
      );
      if (index < 0) {
        return;
      }
      if (this.addition_editing_id < 0) {
        this.data.addition.splice(index, 1);
      } else {
        this.data.addition.splice(index, 1, this.addition_old_item);
      }
      this.addition_editing_id = 0;
    },
    handleClickCancelSubtraction(item) {
      let index = this.data.subtraction.findIndex((i) => i.id === item.id);
      if (index < 0) {
        return;
      }
      if (item.id < 0) {
        this.data.subtraction.splice(index, 1);
      } else {
        this.data.subtraction.splice(index, 1, this.subtraction_old_item);
      }
      this.subtraction_editing_id = 0;
    },
    handleClickUpdateAddition(item) {
      if (!item.product_id) {
        this.util.notify_warning(this, this.title, "품목을 선택해 주세요.");
        return;
      }
      if (!this.validReferenceProduct(item.product_id)) {
        return;
      }
      if (!this.validAdditionProduct(item.product_id, item.id)) {
        return;
      }
      if (!this.validSubtractionProduct(item.product_id)) {
        return;
      }
      this.addition_editing_id = 0;
    },
    handleClickUpdateSubtraction(item) {
      if (!item.product_id) {
        this.util.notify_warning(this, this.title, "품목을 선택해 주세요.");
        return;
      }
      if (!this.validAdditionProduct(item.product_id)) {
        return;
      }
      if (!this.validSubtractionProduct(item.product_id, item.id)) {
        return;
      }
      this.subtraction_editing_id = 0;
    },
    handleClickRemoveAddition(item) {
      let index = this.data.addition.findIndex((i) => i.id === item.id);
      if (index < 0) {
        return;
      }
      this.data.addition.splice(index, 1);
    },
    handleClickRemoveSubtraction(item) {
      let index = this.data.subtraction.findIndex((i) => i.id === item.id);
      if (index < 0) {
        return;
      }
      this.data.subtraction.splice(index, 1);
    },
    handleClickRegister() {
      if (!this.has_grant_write) return;

      if (!this.is_registerable) {
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.doRegister();
      });
    },
    handleClickDelete() {
      this.util.confirm_delete(this, this.title, this.doDelete);
    },
    handleResult(res, successMessage) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, successMessage);
      this.$emit("completed");
    },
  },
};
</script>
